import { cx } from "../cx";

export interface ProgressProps {
  value: number;
  max: number;
  label: string;
  /** LED colour: cyan (default), green (share of a total) or amber. */
  tone?: "cyan" | "green" | "amber";
  class?: string;
}

/** Segmented LED progress bar (XP, weapon levels). A zero `max` renders full (max level reached). */
export function Progress({ value, max, label, tone = "cyan", class: cls }: ProgressProps) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 100;
  return (
    <div
      class={cx("progress", `progress--${tone}`, cls)}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={max > 0 ? max : 1}
      aria-valuenow={max > 0 ? value : 1}
    >
      <span class="progress__fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
